import React from 'react';

type Props = {
  isPreview: boolean | null | undefined;
};

const PreviewBanner: React.FC<Props> = ({ isPreview }) => {
  if (!isPreview) {
    return null;
  }
  return (
    <div
      className="preview-banner"
      role="status"
      aria-live="polite"
      aria-label="Preview"
    >
      Preview
    </div>
  );
};

export default PreviewBanner;
